import { readableColor } from 'polished';

export default function getSafeReadableColor(
  color,
  ifLight = '#000000',
  ifDark = '#ffffff',
) {
  try {
    return readableColor(color, ifLight, ifDark);
  } catch (e) {
    return '#000000';
  }
}
